<template>
    <section class="landscape-products-wrap" v-if="hasAnyProduct">
        <div class="container">
            <div class="tab-products-header clearfix">

                <h2 class="section-title float-left">Ces articles <b>peuvent vous intéresser</b></h2>
            </div>

            <div class="landscape-products" ref="productsPlaceholder">
                <ProductCard v-for="(product, index) in JSON.parse(data)" :key="index" :product="product"></ProductCard>
            </div>
        </div>
    </section>
</template>

<script>


import ProductCard from './../ProductCard.vue';
import { slickPrevArrow, slickNextArrow } from '../../functions';

export default {
    components: { ProductCard },

    props: ['data'],

    computed: {
        hasAnyProduct() {

            let dataArray;
            try {
                dataArray = JSON.parse(this.data);
            } catch (error) {
                return false;
            }
            return Array.isArray(dataArray) && dataArray.length !== 0;

        },
    },

    mounted() {
        $(this.$refs.productsPlaceholder).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            
            autoplay: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            rtl: window.FleetCart.rtl,
            prevArrow: slickPrevArrow(),
            nextArrow: slickNextArrow(),
            responsive: [
                {
                    breakpoint: 1761,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    },
                },
                {
                    breakpoint: 1301,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
                {
                    breakpoint: 1051,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
                {
                    breakpoint: 881,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 641,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });
    },
};
</script>
